/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Nav1Inputs */

const vi_guidevideo_nav1 = /** @type {(inputs: Guidevideo_Nav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video hướng dẫn sử dụng`)
};

/**

* @param {Guidevideo_Nav1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_nav1 = /** @type {((inputs?: Guidevideo_Nav1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Nav1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_nav1(inputs)
});
export { guidevideo_nav1 as "guideVideo_nav" }